import { Subject } from '@reactivex/rxjs'

export const addFake$ = new Subject()
export const switchSelected$ = new Subject()



// WEBPACK FOOTER //
// ./intents.js